"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessInfo = void 0;
exports.BusinessInfo = {
    millionshow_name: '상호명',
    millionshow_ceo_name: '대표자명',
    millionshow_address: '주소',
    millionshow_contact: '연락처',
    millionshow_email: '이메일',
    millionshow_business_number: '사업자등록번호',
    millionshow_copyright: 'COPYRIGHT',
};
